import React, { createContext, useContext, useState } from "react";
import axios from "axios";

const ReceiptVoucherContext = createContext();

export const ReceiptVoucherProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [vouchers, setVouchers] = useState([]);

  const createReceiptVoucher = async (voucherData) => {
    setLoading(true);
    setError(null);
    setSuccess(null);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/receiptVoucher/newReceiptVoucher.php`,
        voucherData,
        { withCredentials: true }
      );
      setSuccess(response.data.message || "تم إنشاء سند القبض بنجاح");
      setLoading(false);
      return response.data;
    } catch (err) {
      setError(err.response?.data?.message || "حدث خطأ أثناء إنشاء سند القبض");
      setLoading(false);
      throw err;
    }
  };

  const getReceiptVouchers = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/receiptVoucher/getReceiptVouchers.php`,
        { withCredentials: true }
      );
      if (response.data.status === "success") {
        setVouchers(response.data.vouchers);
      }
      setLoading(false);
      return response.data;
    } catch (err) {
      setError(err.response?.data?.message || "حدث خطأ أثناء جلب سندات القبض");
      setLoading(false);
      throw err;
    }
  };

  const getReceiptVoucher = async (id) => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/receiptVoucher/getReceiptVoucher.php?id=${id}`,
        { withCredentials: true }
      );
      setLoading(false);
      return response.data;
    } catch (err) {
      setError(err.response?.data?.message || "حدث خطأ أثناء جلب تفاصيل السند");
      setLoading(false);
      throw err;
    }
  };

  const getCustomerInvoices = async (partyId, partyType = "customer") => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/receiptVoucher/getCustomerInvoices.php?party_type=${partyType}&${
          partyType === "supplier" ? "supplier_id" : "customer_id"
        }=${partyId}`,
        { withCredentials: true }
      );
      setLoading(false);
      return response.data;
    } catch (err) {
      setError(
        err.response?.data?.message || "حدث خطأ أثناء جلب فواتير الزبون"
      );
      setLoading(false);
      throw err;
    }
  };

  const getInvoiceVouchers = async (invoiceId) => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/receiptVoucher/getInvoiceVouchers.php?invoice_id=${invoiceId}`,
        { withCredentials: true }
      );
      setLoading(false);
      return response.data;
    } catch (err) {
      setError(
        err.response?.data?.message || "حدث خطأ أثناء جلب سندات الفاتورة"
      );
      setLoading(false);
      throw err;
    }
  };

  const deleteReceiptVoucher = async (voucherId) => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/receiptVoucher/deleteReceiptVoucher.php`,
        { voucher_id: voucherId },
        { withCredentials: true }
      );
      setLoading(false);
      return response.data;
    } catch (err) {
      setError(err.response?.data?.message || "حدث خطأ أثناء حذف سند القبض");
      setLoading(false);
      throw err;
    }
  };

  return (
    <ReceiptVoucherContext.Provider
      value={{
        loading,
        error,
        success,
        vouchers,
        createReceiptVoucher,
        getReceiptVouchers,
        getReceiptVoucher,
        getCustomerInvoices,
        getInvoiceVouchers,
        deleteReceiptVoucher,
      }}
    >
      {children}
    </ReceiptVoucherContext.Provider>
  );
};

export const useReceiptVoucherContext = () => useContext(ReceiptVoucherContext);
